function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import { useTheme } from '@veneer/theme';
import { FloatingArrow as FloatingUiArrow } from '@floating-ui/react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var FloatingArrow = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    context
  } = _ref;
  var theme = useTheme();
  var isHc = theme.mode === 'contrast';
  var hcArrow = {
    fill: theme.color.background.container.default,
    stroke: theme.color.spotlight.background.default,
    strokeWidth: 2,
    width: parseInt(theme.layout.size3),
    height: parseInt(theme.layout.size2) - 2
  };
  return ___EmotionJSX(FloatingUiArrow, _extends({
    context: context,
    ref: ref,
    fill: theme.color.spotlight.background.default,
    width: parseInt(theme.layout.size4),
    height: parseInt(theme.layout.size2)
  }, isHc && hcArrow));
});
FloatingArrow.displayName = 'FloatingArrow';
export default FloatingArrow;